import { render, staticRenderFns } from "./add-citizen.vue?vue&type=template&id=ef0a0f84"
import script from "./add-citizen.vue?vue&type=script&lang=ts"
export * from "./add-citizen.vue?vue&type=script&lang=ts"
import style0 from "./add-citizen.vue?vue&type=style&index=0&id=ef0a0f84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports